<div class="navbar navbar-dark navbar-expand-lg navbar-static border-bottom border-bottom-white border-opacity-10">
	<div class="container-fluid">
  
	  <div class="d-flex d-lg-none me-2">
		<button type="button" class="navbar-toggler sidebar-mobile-main-toggle rounded-pill">
		  <i class="ph-list"></i>
		</button>
	  </div>
  
	  <div class="navbar-brand flex-1 flex-lg-0">
		<a [routerLink]="['/home']" class="d-inline-flex align-items-center">
		  <img src="images/iit-madras-logo.png" class="h-32px">
		  <h1 class="d-none d-sm-inline-block h-24px ms-1 text-white">MANGO</h1>
		</a>
	  </div>

<!-- <div class="navbar-brand flex-1 flex-lg-0">
  <a [routerLink]="['/home']" class="navbar-brand-6">
    <img src="images/iit-madras-logo.png" alt="MANGO Logo" >
    
  </a>
</div> -->
  
	  <!-- Project Selection -->
	  <div class="d-flex align-items-center me-3" *ngIf="showProjectDropdown">
		<label for="projectSelect" class="text-white me-2 mb-0 fw-bold">Project:</label>
		<!-- <select id="projectSelect" class="form-select form-select-sm" [(ngModel)]="selectedProject" (change)="setProject()">
		  <option [value]="''">Default Project</option>
		  <option *ngFor="let project of projects" [value]="project.project._id">{{ project.project.name }}</option>
		</select> -->

		<!-- <ng-select
			id="projectSelect"
			style="min-width: 200px;"
			class="form-select-sm"
			[(ngModel)]="selectedProject"
			(change)="setProject()"
			[items]="projects"
			
			bindValue="project._id"
			placeholder="Default Project"
			[clearable]="false">
			<ng-template ng-label-tmp let-item="item">
				{{ item['project._id'] }}
			</ng-template>

			<ng-template ng-option-tmp let-item="item">
				<div class="d-flex flex-column">
					<span class="fw-bold">{{ item.project?.name }}</span>
					<span class="text-muted small" *ngIf="item.project?.code != ''">
						({{ item.project?.code }})
					</span>
				  </div>
			</ng-template>
		</ng-select> -->


		<ng-select 
			id="projectSelect"
			style="min-width: 200px;"
			class="form-select-sm"
			[items]="projects" 
			[clearable]="false"
			[(ngModel)]="selectedProject"
			bindLabel="name" 
			bindValue="_id" 
      [disabled]="isViewRoute"
			placeholder="Select a Project"
			(change)="setProject()">
			<!-- <ng-template ng-label-tmp let-item="item">
				{{ item?.name }}
			</ng-template> -->
			<ng-template ng-option-tmp let-item="item">
				<div class="d-flex flex-column">
					<span class="fw-bold">{{ item?.name }}</span>
					<span class="text-muted small" *ngIf="item?.code != ''">
						({{ item?.code }})
					</span>
				  </div>
			</ng-template>
		</ng-select>
		
		<!-- Icon Button for New Project -->
		<button *ngIf="!isViewRoute" class="btn btn-sm btn-primary ms-2 d-flex align-items-center" (click)="createProjectModal.openModal()">
		  <i class="ph-plus"></i> <!-- Replace with your preferred icon -->
		</button>
	  </div>
	  
  
	  <!-- User Menu -->
	  <ul class="nav flex-row justify-content-end order-1 order-lg-2">
		<li class="nav-item nav-item-dropdown-lg dropdown" #dropdownContainer>
		  <a href="#" class="navbar-nav-link align-items-center rounded-pill" (click)="toggleDropdown($event)">
			<img src="images/users/user.jpg" class="w-32px h-32px rounded-pill" alt="User">
			<span class="d-none d-lg-inline-block mx-lg-2">{{ account.full_name | titlecase }}</span>
		  </a>
		  <div class="dropdown-menu dropdown-menu-start" [class.show]="isDropdownOpen">
			<!-- <a [routerLink]="['/profile']" class="dropdown-item">
			  <i class="ph-user-circle me-2"></i> My profile
			</a>
			<div class="dropdown-divider"></div> -->
			<a (click)="profileModal.openModal()" class="dropdown-item cursor-pointer">
			  <i class="ph-user-circle me-2"></i> My Profile
			</a>
			<a *ngIf="hasTokenPermission()" 
				(click)="openTokenModal(myTokenRef)" 
				class="dropdown-item cursor-pointer">
				<i class="ph-key me-2"></i> My API Token
			</a>
			<a (click)="logout()" class="dropdown-item cursor-pointer">
			  <i class="ph-sign-out me-2"></i> Logout
			</a>
		  </div>
		</li>
	  </ul>
	</div>
</div>

<ng-template #myToken let-modal>
    <app-token-management #tokenMgmt
        [user]="account"
        [tokenData]="selectedUserToken"
        [isLoading]="isTokenFetching"
        [freshToken]="freshToken"
        [config]="tokenConfig"
        (onGenerate)="handleGenerateToken($event)"
        (onRevoke)="handleRevokeToken($event)"
        (onClose)="modal.dismiss()">
    </app-token-management>
</ng-template>

<app-create-project #createProjectModal (projectCreated)="onProjectCreated($event)"></app-create-project>
<app-profile-modal #profileModal [account]="account" (onUpdated)="onProfileUpdated($event)"></app-profile-modal>